module.exports = __webpack_public_path__ + "static/media/05.5c758ba5.png";